<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <a-form :form="form" v-else>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="No SPPD">
          <a-select
            :disabled="active || mode === 'Edit'"
            showSearch
            placeholder="Select No. SPPD/S"
            @change="handleNo"
            v-decorator="[
              'no_sppd',
              {
                rules: [{ required: true }],
                initialValue: initialData.no_sppd,
              },
            ]"
          >
            <a-select-option v-for="item in listNoSPPD" :key="item.no_sppd">{{
              item.no_sppd
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <div class="container-essential">
          <ul style="list-style: none;padding-inline-start: 0px;">
            <li>
              <div class="ant-form-item" for>Assignee :</div>
              <small><span class="m-list-desc" v-for="(items, index) in assignee" :key="items.tlc">
                {{index+1}}. {{items.tlc}}-{{items.nama}} <br/> &nbsp;&nbsp;&nbsp;&nbsp;({{ items.kategori }};
                {{
                  initialData.no_sppd.includes("PD.") ? ("Ins. SPPD:"+ formatCurrency('IDR', items.ins_sppd)+" | Ins. SPPD LN:"+ formatCurrency('USD', items.ins_sppd_ex)) : 
                  (!initialData.no_sppd.includes("PD.") ? "Ins. SPPS:"+items.ins_spps+"%" : "-")
                }})
              </span></small>
            </li>
          </ul>
        </div>
        <a-form-item label="Reporting Date">
          <a-date-picker
            placeholder="Select Date"
            :disabled="true"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pelaporan',
              {
                rules: [{ required: true }],
                initialValue: initialData.tanggal_pelaporan,
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="No CC">
          <a-select
            showSearch
            placeholder="Select No. CC"
            :filterOption="handleFilter"
            v-decorator="[
              'id_user_cc',
              {
                rules: [{ required: true }],
                initialValue: initialData.id_user_cc,
              },
            ]"
          >
            <a-select-option v-for="item in list_CC" :key="item.id_user_cc">
              {{item.no_cc}} ({{ item.type_cc }} / {{ formatCurrency("IDR",item.limit_kredit) }})
            </a-select-option>
          </a-select>
        </a-form-item>
        <div style="display:none">
        <a-form-item label="Vice President Finance Approval">
          <a-input
            disabled
            v-decorator="[
              'bod',
              { rules: [{ required: true }], initialValue: initialData.bod },
            ]"
          ></a-input>
        </a-form-item>
        </div>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "informasiKlaimPd",
  props: {
    data: {},
    others: {},
    mode: String,
    active: false,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      list_CC: [],
      listNoSPPD: [],
      assignee:[],
      pageLoading: true,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  async mounted() {
    console.log("mounted", this.mode, !this.active)
    if (this.mode === "Create" && !this.active) {
      this.listNoSPPD = [];
      await this.fetchKlaimPD(this.data?this.data.id_sppd: null).then((response)=>{
        console.log("fetchKlaimPD", response)
        if(this.listNoSPPD.length>0 && this.data && this.data.id_sppd){
          let data = this.listNoSPPD.filter(
              (obj) => obj.id_sppd.toLowerCase().indexOf(this.data.id_sppd.toLowerCase()) >= 0
            );
          this.assignee = data[0].assignee;
        }
      });
    } else {
      await this.fetchKlaimPD(this.data?this.data.id_sppd: null)
      this.assignee = this.others.assignee;
      this.pageLoading = false;
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          no_sppd: [],
          tanggal_pelaporan: moment(),
          atasan: "",
          pimpro: "",
          actor_label: "Actor",
          actor: "",
          peruntukan: "",
          bod: "",
          catatan: "",
          id_user_cc: "",
        };
      } else {
        let peruntukan = "";
        if (this.mode === "Create") {
          peruntukan = this.data.peruntukan;
        } else {
          peruntukan = this.others.peruntukan;
        }
        return {
          no_sppd: this.data.no_sppd,
          tanggal_pelaporan: moment(this.data.tanggal_pelaporan),
          pimpro: this.data.pimpro,
          id_sppd: this.data.id_sppd,
          bod: this.data.bod,
          // bod_name : this.data.bod_name,
          peruntukan: peruntukan,
          catatan: this.data.catatan,
          id_user_cc: this.data.id_user_cc,
        };
      }
    },
  },
  methods: {
    moment,
    async fetchKlaimPD(isexistSPPD) {
      let params = {
        tlc : this.getAuth.username
      }
      if(isexistSPPD){
        params['id_sppd'] = isexistSPPD
      }
      await axios({
        method: "get",
        url: this.$serviceUrl + "klaim_cc_pd/no_sppd",
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.listNoSPPD = response.data.no_sppd;
          this.list_CC = response.data.no_cc;
          this.pageLoading = false;
        })
        .catch((err) => {
          if (this.mode === "Create") {
            let response = Object.assign({}, err.response.data);
            if (response.message === "Tidak Memiliki No SPPD") {
              this.displayMessage("no-active-sppd");
            } else {
              this.displayMessage("404");
            }
            // this.$router.go(-1);
          } else {
            this.pageLoading = false;
            this.loading = false;
          }
        });
    },
    handleNo(e) {
      let data = {};
      data = this.listNoSPPD.filter(
        (obj) => obj.no_sppd.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.initialData.pimpro = data[0].pimpro;
      this.initialData.peruntukan = data[0].peruntukan;
      this.initialData.bod = data[0].bod + " - " + data[0].nama_bod;
      this.initialData.id_sppd = data[0].id_sppd;
      this.initialData.no_sppd = data[0].no_sppd;
      this.assignee = data[0].assignee;
      this.form.setFieldsValue({
        actor: this.initialData.actor,
        bod: this.initialData.bod,
      });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const informasi = {
          tanggal_pelaporan: values.tanggal_pelaporan,
          no_sppd: values.no_sppd,
          id_sppd: this.initialData.id_sppd,
          pimpro: values.pimpro || "",
          peruntukan: this.initialData.peruntukan || "",
          bod: this.initialData.bod,
          catatan : this.initialData.catatan,
          id_user_cc: values.id_user_cc
          // bod_name: this.initialData.bod_name,
        };

        Event.$emit("lapUmpd", informasi);
      });
    },
    beforeRouteEnter(to, from, next) {
      fetchKlaimPD((err, post) => {
        next();
      });
    },
    clearForm() {
      this.form.resetFields();
    },
    handleFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
  },
  watch: {
    "others"() {
      if(this.others.assignee){
        this.assignee = this.others.assignee
      }
    }
  }
};
</script>

<style></style>
